(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {

      this.header =
        document.querySelector('.section-header');

      this.mobileMediaQuery =
        window.matchMedia('(max-width: 990px)');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always'
        ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener(
        'change',
        this.setHeaderHeight
      );

      if (this.headerIsAlwaysSticky) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      }

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearches =
        this.querySelectorAll('predictive-search');

      this.onScrollHandler =
        () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            this.onScroll();
          });
        };

      this.hideHeaderOnScrollUp =
        () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        { passive: true }
      );

      this.createObserver();

    }


    setHeaderHeight() {

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }


    disconnectedCallback() {
      cancelAnimationFrame(this.scrollFrame);

      this.mobileMediaQuery.removeEventListener(
        'change',
        this.setHeaderHeight
      );

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }


    createObserver() {

      let observer =
        new IntersectionObserver(
          (entries, observer) => {

            this.headerBounds =
              entries[0].intersectionRect;

            observer.disconnect();

          }
        );

      observer.observe(this.header);

    }


    onScroll() {

      const scrollTop =
        window.pageYOffset
        ||
        document.documentElement.scrollTop;

      if (
        [...this.predictiveSearches].some(
          (predictiveSearch) =>
            predictiveSearch.isOpen
        )
      ) return;


      if (
        scrollTop > this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) return;

        requestAnimationFrame(
          this.hide.bind(this)
        );

      }

      else if (
        scrollTop < this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        }

        else {

          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(
              () => {
                this.preventReveal = false;
              },
              66
            );

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      }

      else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );

      }

      this.currentScrollTop =
        scrollTop;

    }


    hide() {

      if (this.headerIsAlwaysSticky || this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }


    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }


    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }


    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures
        ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) =>
          disclosure.close()
      );

    }


    closeSearchModal() {

      this.searchModals =
        this.searchModals
        ||
        this.header.querySelectorAll(
          'details-modal'
        );

      this.searchModals.forEach(
        (searchModal) =>
          searchModal.close(false)
      );

    }

  }


  customElements.define(
    'sticky-header',
    StickyHeader
  );


  document.addEventListener(
    'open',

    (event) => {

      if (
        !(event.target instanceof HTMLElement)
        ||
        !event.target.matches('shopify-account')
      ) return;


      const bottom =
        Math.max(
          0,
          Math.round(
            event.target
              .getBoundingClientRect()
              .bottom
          )
        );


      event.target.style.setProperty(
        '--account-dialog-top',
        `${bottom}px`
      );

    },

    true
  );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpc-faq-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kpc-faq').forEach((faq) => {
    const links = Array.from(faq.querySelectorAll('.kpc-faq__nav a'));

    const sections = links
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if (!links.length || !sections.length) return;

    const setActiveLink = (id) => {
      links.forEach((link) => {
        if (link.getAttribute('href') === `#${id}`) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    setActiveLink(sections[0].id);

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort(
            (firstEntry, secondEntry) =>
              firstEntry.boundingClientRect.top -
              secondEntry.boundingClientRect.top
          );

        if (visible[0]) {
          setActiveLink(visible[0].target.id);
        }
      },
      {
        rootMargin: '-18% 0px -70% 0px',
        threshold: 0
      }
    );

    sections.forEach((category) => observer.observe(category));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpc-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kpc-social-proof')) {
    customElements.define('kpc-social-proof', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true' || window.matchMedia('(max-width: 749px)').matches) return;
        this.dataset.ready = 'true';

        const source = this.querySelector('script[type="application/json"]');
        if (!source) return;

        try {
          this.events = JSON.parse(source.textContent).filter((event) => {
            if (!event.customer || !event.city || !event.product || !event.url || !event.image || !event.purchasedAt) return false;
            const age = Date.now() - new Date(event.purchasedAt).getTime();
            return age >= 0 && age <= 60 * 24 * 60 * 60 * 1000;
          });
        } catch (error) {
          this.events = [];
        }

        if (!this.events.length || sessionStorage.getItem('kpc-proof-dismissed') === 'true') return;

        this.link = this.querySelector('.kpc-social-proof__link');
        this.image = this.querySelector('.kpc-social-proof__image');
        this.customer = this.querySelector('.kpc-social-proof__customer');
        this.product = this.querySelector('.kpc-social-proof__product');
        this.time = this.querySelector('.kpc-social-proof__time');
        this.closeButton = this.querySelector('.kpc-social-proof__close');
        this.index = Number(sessionStorage.getItem('kpc-proof-index') || 0) % this.events.length;
        this.initialDelay = Number(this.dataset.initialDelay) || 8000;
        this.displayTime = Number(this.dataset.displayTime) || 10000;
        this.repeatDelay = Number(this.dataset.repeatDelay) || 45000;

        this.closeButton.addEventListener('click', () => this.dismiss());
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());

        this.showTimer = window.setTimeout(() => this.show(), Shopify.designMode ? 300 : this.initialDelay);
      }

      relativeTime(dateString) {
        const seconds = Math.max(0, Math.floor((Date.now() - new Date(dateString).getTime()) / 1000));
        if (seconds < 3600) return 'Less than an hour ago';
        const hours = Math.floor(seconds / 3600);
        if (hours < 24) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
        const days = Math.floor(hours / 24);
        return `${days} ${days === 1 ? 'day' : 'days'} ago`;
      }

      locationName(location) {
        const parts = location.split(',').map((part) => part.trim()).filter(Boolean);
        return parts[parts.length - 1] || location.trim();
      }

      show() {
        const event = this.events[this.index];
        this.link.href = event.url;
        this.link.setAttribute('aria-label', `View ${event.product}`);
        this.image.src = event.image;
        this.image.alt = event.imageAlt || event.product;
        this.customer.textContent = `${event.customer} in ${this.locationName(event.city)}`;
        this.product.textContent = event.product;
        this.time.dateTime = event.purchasedAt;
        this.time.textContent = this.relativeTime(event.purchasedAt);
        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-visible'));
        this.hideTimer = window.setTimeout(() => this.hide(), this.displayTime);
      }

      hide() {
        window.clearTimeout(this.hideTimer);
        this.classList.remove('is-visible');
        this.index = (this.index + 1) % this.events.length;
        sessionStorage.setItem('kpc-proof-index', String(this.index));
        this.concealTimer = window.setTimeout(() => {
          this.hidden = true;
          this.showTimer = window.setTimeout(() => this.show(), this.repeatDelay);
        }, 200);
      }

      pause() {
        if (!this.classList.contains('is-visible')) return;
        window.clearTimeout(this.hideTimer);
      }

      resume() {
        if (!this.classList.contains('is-visible')) return;
        window.clearTimeout(this.hideTimer);
        this.hideTimer = window.setTimeout(() => this.hide(), this.displayTime);
      }

      dismiss() {
        sessionStorage.setItem('kpc-proof-dismissed', 'true');
        window.clearTimeout(this.showTimer);
        window.clearTimeout(this.hideTimer);
        window.clearTimeout(this.concealTimer);
        this.classList.remove('is-visible');
        window.setTimeout(() => { this.hidden = true; }, 200);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpc-woodwool-comparison"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.kpc-compare__faq-list').forEach(list=>{const items=[...list.querySelectorAll('details')];items.forEach(item=>item.addEventListener('toggle',()=>{if(item.open)items.forEach(other=>{if(other!==item)other.open=false})}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krinkle-request-quote"] && !Shopify.designMode) return;
  try {
    

(()=>{
  const money=(cents,currency)=>
    new Intl.NumberFormat(
      'en-ZA',
      {
        style:'currency',
        currency:currency||'ZAR'
      }
    ).format((Number(cents)||0)/100);

  const init=root=>{

    if(root.dataset.ready==='true'){
      return;
    }

    root.dataset.ready='true';

    const q=s=>root.querySelector(s);
    const qa=s=>[...root.querySelectorAll(s)];

    const data=JSON.parse(
      q('[data-kpc-products]')?.textContent||'[]'
    ).filter(p=>p.eligible);

    const type=q('[data-kpc-type]');
    const product=q('[data-kpc-product]');
    const variant=q('[data-kpc-variant]');
    const qty=q('[data-kpc-quantity]');
    const add=q('[data-kpc-add]');
    const blend=q('[data-kpc-blend]');
    const status=q('[data-kpc-builder-status]');
    const stepStatus=q('[data-kpc-step-status]');
    const next=q('[data-kpc-next]');
    const back=q('[data-kpc-back]');
    const submit=q('[data-kpc-submit]');

    let step=0;
    let cart=null;

    function escapeHtml(v){
      const d=document.createElement('div');
      d.textContent=v??'';
      return d.innerHTML;
    }

    function cleanType(item){
      const value=String(item?.type||'').trim();

      if(value){
        return value;
      }

      return String(
        item?.sourceCollection||'Products'
      ).trim() || 'Products';
    }

    function productLabel(item){
      if(item?.customBlend){
        return 'Custom Blend';
      }

      if(String(item?.displayTitle||'').trim()){
        return String(item.displayTitle).trim();
      }

      return String(
        item?.title||'Product'
      ).trim();
    }

    function cartItemLabel(item){
      const source=data.find(
        entry=>String(entry.id)===String(item.product_id)
      );

      return source
        ? productLabel(source)
        : String(item.product_title||'Product');
    }

    function sizeRank(title){
      const lower=String(title||'').toLowerCase();

      const kg=lower.match(/(\d+(?:\.\d+)?)\s*kg\b/);
      const grams=lower.match(/(\d+(?:\.\d+)?)\s*g\b/);

      if(kg){
        return Number(kg[1])*1000000;
      }

      if(grams){
        return Number(grams[1])*1000;
      }

      const values=lower.match(/\d+(?:\.\d+)?/g);

      return values
        ? values.slice(0,3).map(Number).reduce((a,b)=>a*b,1)
        : 0;
    }

    const types=[
      ...new Set(
        data.map(cleanType).filter(Boolean)
      )
    ].sort(
      (a,b)=>a.localeCompare(
        b,
        undefined,
        {sensitivity:'base'}
      )
    );

    types.forEach(t=>{
      type?.insertAdjacentHTML(
        'beforeend',
        `<option value="${escapeHtml(t)}">${escapeHtml(t)}</option>`
      );
    });

    function selectedProduct(){
      return data.find(
        p=>String(p.id)===product?.value
      );
    }

    function selectedColours(){
      return qa('[data-kpc-colour]:checked')
        .map(input=>input.value);
    }

    function setStatus(el,message,error=false){
      if(!el){
        return;
      }

      el.textContent=message||'';
      el.classList.toggle('is-error',error);
    }

    function resetBlend(){
      qa('[data-kpc-colour]').forEach(
        input=>{
          input.checked=false;
          input.disabled=false;
        }
      );

      const count=q('[data-kpc-colour-count]');

      if(count){
        count.textContent='0';
      }
    }

    function fillProducts(){
      if(!product || !variant){
        return;
      }

      product.innerHTML='<option value="">Choose a product</option>';
      variant.innerHTML='<option value="">Choose a size / variant</option>';

      const selectedType=type.value;

      data
        .filter(item=>cleanType(item)===selectedType)
        .map(item=>({
          item,
          label:productLabel(item)
        }))
        .sort(
          (a,b)=>a.label.localeCompare(
            b.label,
            undefined,
            {sensitivity:'base'}
          )
        )
        .forEach(
          ({item,label})=>
            product.insertAdjacentHTML(
              'beforeend',
              `<option value="${item.id}">${escapeHtml(label)}</option>`
            )
        );

      product.disabled=!selectedType;
      variant.disabled=true;
      add.disabled=true;

      if(blend){
        blend.hidden=true;
      }

      resetBlend();
    }

    function fillVariants(){
      const p=selectedProduct();

      variant.innerHTML='<option value="">Choose a size / variant</option>';

      if(p){
        p.variants
          .filter(v=>v.available)
          .sort(
            (a,b)=>sizeRank(b.title)-sizeRank(a.title)
          )
          .forEach(
            v=>
              variant.insertAdjacentHTML(
                'beforeend',
                `<option value="${v.id}">${escapeHtml(v.title)} — ${money(v.price,root.dataset.currency)}</option>`
              )
          );
      }

      variant.disabled=!p;

      resetBlend();

      if(blend){
        blend.hidden=!p?.customBlend;
      }

      checkAdd();
    }

    function updateColours(){
      const chosen=selectedColours();

      const count=q('[data-kpc-colour-count]');

      if(count){
        count.textContent=chosen.length;
      }

      qa('[data-kpc-colour]').forEach(
        input=>{
          input.disabled=
            !input.checked
            &&
            chosen.length>=5;
        }
      );
    }

    function checkAdd(){
      if(!add){
        return;
      }

      add.disabled=
        !variant?.value
        ||
        Number(qty?.value)<1;
    }

    function updateStepOneCTA(){
      if(!next || step!==0){
        return;
      }

      next.textContent='Continue';

      next.disabled=
        !cart
        ||
        !Array.isArray(cart.items)
        ||
        cart.items.length===0;
    }

    async function getCart(){
      const response=await fetch(
        (root.dataset.root||'/')+'cart.js',
        {
          headers:{
            Accept:'application/json'
          }
        }
      );

      if(!response.ok){
        throw new Error(
          'Cart could not be loaded.'
        );
      }

      cart=await response.json();

      renderCart();
      updateStepOneCTA();

      return cart;
    }

    function renderCart(){
      const lines=q('[data-kpc-cart-lines]');
      const count=q('[data-kpc-cart-count]');
      const totals=q('[data-kpc-totals]');

      if(!lines||!cart){
        return;
      }

      if(count){
        count.textContent=cart.item_count;
      }

      if(!cart.items.length){
        lines.innerHTML=
          '<p class="kpc-order__empty">Your order is empty. Add a product to begin.</p>';

        if(totals){
          totals.hidden=true;
        }

        return;
      }

      lines.innerHTML=cart.items.map(
        item=>`

          <div class="kpc-order-line">

            ${
              item.image
              ? `<img src="${item.image}" alt="" loading="lazy" decoding="async" width="80" height="80">`
              : '<span></span>'
            }

            <div class="kpc-order-line__text">

              <strong>
                ${escapeHtml(cartItemLabel(item))}
              </strong>

              <span>
                ${escapeHtml(item.variant_title||'')}
                · Qty ${item.quantity}
              </span>

              ${
                Object.entries(item.properties||{})
                  .filter(([,value])=>value)
                  .map(
                    ([key,value])=>
                      `<small>${escapeHtml(key)}: ${escapeHtml(value)}</small>`
                  )
                  .join('')
              }

            </div>

            <div class="kpc-order-line__price">

              <strong>
                ${money(item.final_line_price,cart.currency)}
              </strong>

              <button
                type="button"
                data-remove-key="${escapeHtml(item.key)}"
              >
                Remove
              </button>

            </div>

          </div>

        `
      ).join('');

      if(totals){
        totals.hidden=false;
      }

      const subtotal=q('[data-kpc-subtotal]');

      if(subtotal){
        subtotal.textContent=
          money(
            cart.items_subtotal_price,
            cart.currency
          );
      }
    }

    async function addItem(){
      const p=selectedProduct();
      const properties={};

      if(p?.customBlend){
        const chosen=selectedColours();

        if(chosen.length){
          properties['Blend colours']=
            chosen.join(', ');
        }
      }

      add.disabled=true;

      setStatus(
        status,
        'Adding to your order…'
      );

      try{
        const response=await fetch(
          (root.dataset.root||'/')+'cart/add.js',
          {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              Accept:'application/json'
            },
            body:JSON.stringify({
              items:[
                {
                  id:Number(variant.value),
                  quantity:Number(qty.value),
                  properties
                }
              ]
            })
          }
        );

        if(!response.ok){
          const error=
            await response.json();

          throw new Error(
            error.description
            ||
            'This product could not be added.'
          );
        }

        await getCart();

        setStatus(
          status,
          'Added to your order.'
        );

        qty.value=1;
        resetBlend();
      }
      catch(error){
        setStatus(
          status,
          error.message,
          true
        );
      }
      finally{
        checkAdd();
        updateStepOneCTA();
      }
    }

    async function removeItem(key){
      try{
        const response=await fetch(
          (root.dataset.root||'/')+'cart/change.js',
          {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              Accept:'application/json'
            },
            body:JSON.stringify({
              id:key,
              quantity:0
            })
          }
        );

        if(!response.ok){
          throw new Error(
            'This item could not be removed.'
          );
        }

        await getCart();
        updateStepOneCTA();
      }
      catch(error){
        setStatus(
          status,
          error.message,
          true
        );
      }
    }

    function requiredFieldsValid(container){
      const fields=[
        ...container.querySelectorAll('[required]')
      ].filter(
        field=>!field.closest('[hidden]')
      );

      for(const field of fields){
        if(!field.checkValidity()){
          field.reportValidity();
          return false;
        }
      }

      return true;
    }

    function details(){
      const form=q('form');

      const value=name=>
        form.elements.namedItem(name)?.value||'';

      return{
        document:value('contact[Document requested]'),
        company:value('contact[Company]'),
        contact:value('contact[Contact person]'),
        email:value('contact[email]'),
        phone:value('contact[Phone]'),

        billingCompany:value('contact[Billing company]'),
        billingAddress1:value('contact[Billing address 1]'),
        billingAddress2:value('contact[Billing address 2]'),
        billingCity:value('contact[Billing city]'),
        billingProvince:value('contact[Billing province]'),
        billingPostal:value('contact[Billing postal code]'),
        billingCountry:value('contact[Billing country]'),

        delivery:value('contact[Delivery method]'),
        street:value('contact[Delivery street]'),
        address2:value('contact[Delivery address 2]'),
        suburb:value('contact[Delivery suburb]'),
        city:value('contact[Delivery city]'),
        province:value('contact[Delivery province]'),
        postal:value('contact[Delivery postal code]'),

        required:value('contact[Required by]'),
        notes:value('contact[Order notes]')
      };
    }

    function billingAddressText(d){
      return[
        d.billingCompany,
        d.billingAddress1,
        d.billingAddress2,
        d.billingCity,
        d.billingProvince,
        d.billingPostal,
        d.billingCountry
      ]
        .filter(Boolean)
        .join(', ');
    }

    function deliveryAddressText(d){
      if(d.delivery!=='Courier delivery'){
        return 'Not required';
      }

      return[
        d.street,
        d.address2,
        d.suburb,
        d.city,
        d.province,
        d.postal,
        'South Africa'
      ]
        .filter(Boolean)
        .join(', ');
    }

    function buildReview(){
      if(!cart){
        return;
      }

      const d=details();

      q('[data-kpc-review-order]').innerHTML=
        cart.items.map(
          item=>`

            <div class="kpc-order-line">

              ${
                item.image
                ? `<img src="${item.image}" alt="" loading="lazy" decoding="async" width="80" height="80">`
                : '<span></span>'
              }

              <div class="kpc-order-line__text">

                <strong>
                  ${escapeHtml(cartItemLabel(item))}
                </strong>

                <span>
                  ${escapeHtml(item.variant_title||'')}
                  · Qty ${item.quantity}
                </span>

                ${
                  Object.entries(item.properties||{})
                    .filter(([,value])=>value)
                    .map(
                      ([key,value])=>
                        `<small>${escapeHtml(key)}: ${escapeHtml(value)}</small>`
                    )
                    .join('')
                }

              </div>

              <div class="kpc-order-line__price">

                <strong>
                  ${money(item.final_line_price,cart.currency)}
                </strong>

              </div>

            </div>

          `
        ).join('');

      const deliveryReview=
        d.delivery==='Courier delivery'
        ? `${d.delivery} · ${deliveryAddressText(d)}`
        : d.delivery;

      q('[data-kpc-review-details]').innerHTML=`

        <dt>Document</dt>
        <dd>${escapeHtml(d.document)}</dd>

        <dt>Business</dt>
        <dd>${escapeHtml(d.company)}</dd>

        <dt>Contact</dt>
        <dd>
          ${escapeHtml(d.contact)}
          ·
          ${escapeHtml(d.email)}
        </dd>

        <dt>Billing address</dt>
        <dd>${escapeHtml(billingAddressText(d))}</dd>

        <dt>Delivery</dt>
        <dd>${escapeHtml(deliveryReview)}</dd>

        <dt>Required by</dt>
        <dd>${escapeHtml(d.required||'Not specified')}</dd>

      `;
    }

    function buildConfirmation(){
      const d=details();

      const summary=
        q('[data-kpc-final-summary]');

      if(!summary){
        return;
      }

      summary.innerHTML=`

        <dt>Request</dt>
        <dd>${escapeHtml(d.document)}</dd>

        <dt>Business</dt>
        <dd>${escapeHtml(d.company)}</dd>

        <dt>Products</dt>
        <dd>${cart?.item_count||0}</dd>

        <dt>Delivery</dt>
        <dd>${escapeHtml(d.delivery)}</dd>

      `;
    }

    function showStep(index){
      step=index;

      qa('[data-kpc-step]').forEach(
        (el,i)=>{
          el.hidden=i!==step;

          el.classList.toggle(
            'is-active',
            i===step
          );
        }
      );

      qa('[data-kpc-step-link]').forEach(
        (el,i)=>{
          el.classList.toggle(
            'is-active',
            i===step
          );

          el.classList.toggle(
            'is-complete',
            i<step
          );

          el.disabled=i>step;

          if(i===step){
            el.setAttribute(
              'aria-current',
              'step'
            );
          }
          else{
            el.removeAttribute(
              'aria-current'
            );
          }
        }
      );

      if(back){
        back.hidden=step===0;
      }

      if(step===3){
        if(next){
          next.hidden=true;
        }

        if(submit){
          submit.hidden=false;
          submit.disabled=false;
        }

        const d=details();

        submit.textContent=
          d.document==='Invoice for payment'
          ? 'Submit invoice request'
          : 'Submit quotation request';

        buildConfirmation();
      }
      else{
        if(submit){
          submit.hidden=true;
        }

        if(next){
          next.hidden=false;
        }

        if(step===0){
          next.textContent='Continue';
          updateStepOneCTA();
        }

        if(step===1){
          next.textContent='Continue';
          next.disabled=false;
        }

        if(step===2){
          next.textContent='Confirm & continue';
          next.disabled=false;
          buildReview();
        }
      }

      window.scrollTo({
        top:root.offsetTop-20,
        behavior:'smooth'
      });
    }

    function updateDeliveryAddress(){
      const courier=
        q('[data-kpc-delivery="courier"]')
          ?.checked;

      const address=
        q('[data-kpc-address]');

      if(!address){
        return;
      }

      address.hidden=!courier;

      address
        .querySelectorAll('input,select')
        .forEach(
          field=>{
            const optional=
              field.name==='contact[Delivery address 2]';

            field.required=
              Boolean(courier)
              &&
              !optional;
          }
        );
    }

    function southAfricaDateParts(){
      const formatter=
        new Intl.DateTimeFormat(
          'en-CA',
          {
            timeZone:'Africa/Johannesburg',
            year:'2-digit',
            month:'2-digit',
            day:'2-digit'
          }
        );

      const parts=Object.fromEntries(
        formatter
          .formatToParts(new Date())
          .filter(part=>part.type!=='literal')
          .map(
            part=>[
              part.type,
              part.value
            ]
          )
      );

      return{
        year:parts.year,
        month:parts.month,
        day:parts.day
      };
    }

    function makeReference(){
      const parts=
        southAfricaDateParts();

      const dateKey=
        `${parts.year}${parts.month}${parts.day}`;

      const storageKey=
        `kpcQuoteSequence:${dateKey}`;

      let sequence=1;

      try{
        const previous=Number(
          localStorage.getItem(storageKey)||0
        );

        sequence=
          previous>=1
          &&
          previous<99
          ? previous+1
          : 1;

        localStorage.setItem(
          storageKey,
          String(sequence)
        );
      }
      catch(error){
        if(window.crypto?.getRandomValues){
          const values=
            new Uint32Array(1);

          window.crypto.getRandomValues(values);

          sequence=
            (values[0]%99)+1;
        }
        else{
          sequence=
            Math.floor(Math.random()*99)+1;
        }
      }

      return`KPC-Q-${dateKey}-${String(sequence).padStart(2,'0')}`;
    }

    function submissionDate(){
      return new Intl.DateTimeFormat(
        'en-ZA',
        {
          timeZone:'Africa/Johannesburg',
          dateStyle:'long',
          timeStyle:'medium'
        }
      ).format(new Date());
    }

    function orderText(reference,date){
      if(!cart){
        return'';
      }

      const d=details();

      const lines=cart.items.map(
        (item,index)=>{

          const properties=
            Object.entries(item.properties||{})
              .filter(([,value])=>value)
              .map(
                ([key,value])=>
                  `${key}: ${value}`
              )
              .join('\n');

          return`
${index+1}. ${item.product_title}
Size / variant: ${item.variant_title||'Default'}
SKU: ${item.sku||'N/A'}
Variant ID: ${item.variant_id}
Quantity: ${item.quantity}
${properties ? properties+'\n' : ''}Unit price: ${money(item.final_price,cart.currency)}
Line total: ${money(item.final_line_price,cart.currency)}
          `.trim();

        }
      ).join('\n\n');

      return`
${d.document==='Invoice for payment'?'INVOICE REQUEST':'QUOTATION'} | ${reference} | ${d.company}

KRINKLE PAPER CO.
SOUTH AFRICA BUSINESS REQUEST

REQUEST REFERENCE
${reference}

SUBMITTED
${date}

REQUEST TYPE
${d.document.toUpperCase()}

SHOPIFY CART TOKEN
${cart.token||''}

CUSTOMER
Company: ${d.company}
Contact person: ${d.contact}
Email: ${d.email}
Phone: ${d.phone}

BILLING ADDRESS
Company: ${d.billingCompany||d.company}
Address 1: ${d.billingAddress1}
Address 2: ${d.billingAddress2||'—'}
City: ${d.billingCity}
Province: ${d.billingProvince}
Postal code: ${d.billingPostal}
Country: ${d.billingCountry||'South Africa'}

REQUIRED BY
${d.required||'Not supplied'}

DELIVERY
Method: ${d.delivery}
Address: ${deliveryAddressText(d)}

PRODUCTS
${lines}

PRODUCT SUBTOTAL
${money(cart.items_subtotal_price,cart.currency)}

SHIPPING
TO BE CONFIRMED

CURRENT PRODUCT TOTAL
${money(cart.total_price,cart.currency)}

ORDER NOTES
${d.notes||'None'}

ADMIN ACTION
${
  d.document==='Invoice for payment'
  ? 'Confirm stock, lead time, pricing and shipping before preparing the Draft Order / invoice.'
  : 'Confirm stock, lead time, pricing and shipping before sending the final quotation.'
}
      `.trim();
    }

    async function tagCart(reference,date){
      const d=details();

      const controller=
        new AbortController();

      const timer=
        setTimeout(
          ()=>controller.abort(),
          4000
        );

      try{
        const response=await fetch(
          (root.dataset.root||'/')+'cart/update.js',
          {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              Accept:'application/json'
            },
            body:JSON.stringify({
              note:
                `${d.document.toUpperCase()} REQUEST | ${reference} | ${d.company} | ${d.email} | Review availability, lead time, pricing and shipping before finalising.`,
              attributes:{
                'KPC Request Reference':reference,
                'KPC Request Type':d.document,
                'KPC Company':d.company,
                'KPC Contact':d.contact,
                'KPC Email':d.email,
                'KPC Phone':d.phone,
                'KPC Billing Address':billingAddressText(d),
                'KPC Submitted':date,
                'KPC Request Status':'Submitted for review'
              }
            }),
            signal:controller.signal
          }
        );

        if(!response.ok){
          throw new Error(
            'Cart tagging failed'
          );
        }
      }
      finally{
        clearTimeout(timer);
      }
    }

    function rebuildUrl(){
      if(!cart){
        return'';
      }

      const payload=cart.items.map(
        item=>({
          id:item.variant_id,
          quantity:item.quantity,
          properties:item.properties||{}
        })
      );

      const url=
        new URL(location.href);

      url.search='';
      url.hash='';

      url.searchParams.set(
        'kpc_rebuild',
        JSON.stringify(payload)
      );

      return url.toString();
    }

    async function restoreRequest(){
      const raw=
        new URL(location.href)
          .searchParams
          .get('kpc_rebuild');

      if(!raw){
        return;
      }

      let items;

      try{
        items=JSON.parse(raw);
      }
      catch(error){
        setStatus(
          status,
          'This rebuild link is not valid.',
          true
        );

        return;
      }

      if(
        !Array.isArray(items)
        ||
        !items.length
      ){
        return;
      }

      if(
        !window.confirm(
          'Restore this quote request into the current Shopify cart? This will replace the current cart.'
        )
      ){
        return;
      }

      setStatus(
        status,
        'Restoring the quote request…'
      );

      try{
        await fetch(
          (root.dataset.root||'/')+'cart/clear.js',
          {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              Accept:'application/json'
            }
          }
        );

        const response=await fetch(
          (root.dataset.root||'/')+'cart/add.js',
          {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              Accept:'application/json'
            },
            body:JSON.stringify({
              items:items.map(
                item=>({
                  id:Number(item.id),
                  quantity:Number(item.quantity),
                  properties:item.properties||{}
                })
              )
            })
          }
        );

        if(!response.ok){
          const responseError=
            await response.json()
              .catch(()=>({}));

          throw new Error(
            responseError.description
            ||
            'The saved order could not be restored.'
          );
        }

        await getCart();

        setStatus(
          status,
          'Quote request restored. Opening cart…'
        );

        window.location.assign(
          root.dataset.cartUrl||'/cart'
        );
      }
      catch(error){
        setStatus(
          status,
          error.message,
          true
        );
      }
    }

    type?.addEventListener(
      'change',
      fillProducts
    );

    product?.addEventListener(
      'change',
      fillVariants
    );

    variant?.addEventListener(
      'change',
      checkAdd
    );

    qty?.addEventListener(
      'input',
      checkAdd
    );

    qa('[data-kpc-colour]').forEach(
      input=>
        input.addEventListener(
          'change',
          updateColours
        )
    );

    add?.addEventListener(
      'click',
      addItem
    );

    q('[data-kpc-cart-lines]')?.addEventListener(
      'click',
      event=>{
        const button=
          event.target.closest(
            '[data-remove-key]'
          );

        if(button){
          removeItem(
            button.dataset.removeKey
          );
        }
      }
    );

    qa(
      'input[name="contact[Delivery method]"]'
    ).forEach(
      input=>
        input.addEventListener(
          'change',
          updateDeliveryAddress
        )
    );

    next?.addEventListener(
      'click',
      ()=>{
        setStatus(stepStatus,'');

        if(step===0){
          if(!cart?.items?.length){
            return;
          }

          showStep(1);
          return;
        }

        if(step===1){
          const detailsStep=
            q('[data-kpc-step="1"]');

          updateDeliveryAddress();

          if(
            !requiredFieldsValid(detailsStep)
          ){
            return;
          }

          showStep(2);
          return;
        }

        if(step===2){
          showStep(3);
          return;
        }
      }
    );

    back?.addEventListener(
      'click',
      ()=>
        showStep(
          Math.max(
            0,
            step-1
          )
        )
    );

    qa('[data-kpc-edit]').forEach(
      button=>
        button.addEventListener(
          'click',
          ()=>
            showStep(
              Number(button.dataset.kpcEdit)
            )
        )
    );

    qa('[data-kpc-step-link]').forEach(
      (button,index)=>
        button.addEventListener(
          'click',
          ()=>{
            if(index<=step){
              showStep(index);
            }
          }
        )
    );

    let allowNativeSubmit=false;
    let preparingSubmission=false;

    q('form')?.addEventListener(
      'submit',
      async event=>{
        if(allowNativeSubmit){
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if(preparingSubmission){
          return;
        }

        const form=
          event.currentTarget;

        if(!cart?.items?.length){
          showStep(0);
          return;
        }

        updateDeliveryAddress();

        if(!form.checkValidity()){
          form.reportValidity();
          return;
        }

        preparingSubmission=true;

        const reference=
          makeReference();

        const date=
          submissionDate();

        const d=
          details();

        const subject=
          d.document==='Invoice for payment'
          ? (
            root.dataset.invoiceSubject
            ||
            'INVOICE REQUEST'
          )
          : (
            root.dataset.quotationSubject
            ||
            'QUOTATION'
          );

        q('[data-kpc-hidden="reference"]').value=
          reference;

        q('[data-kpc-hidden="request-date"]').value=
          date;

        q('[data-kpc-hidden="subject"]').value=
          `${subject} | ${reference} | ${d.company}`;

        q('[data-kpc-hidden="request-type"]').value=
          d.document;

        q('[data-kpc-hidden="cart-token"]').value=
          cart.token||'';

        q('[data-kpc-hidden="rebuild-url"]').value=
          rebuildUrl();

        q('[data-kpc-hidden="order-summary"]').value=
          orderText(
            reference,
            date
          );

        submit.disabled=true;

        submit.textContent=
          d.document==='Invoice for payment'
          ? 'Submitting invoice request…'
          : 'Submitting quotation request…';

        try{
          sessionStorage.setItem(
            'kpcQuoteReference',
            reference
          );

          sessionStorage.setItem(
            'kpcQuoteType',
            d.document
          );
        }
        catch(error){
          console.warn(
            'Krinkle: session storage unavailable.',
            error
          );
        }

        try{
          await tagCart(
            reference,
            date
          );
        }
        catch(error){
          console.warn(
            'Krinkle: cart tagging failed, continuing with form submission.',
            error
          );
        }

        allowNativeSubmit=true;

        preparingSubmission=false;
        submit.disabled=false;
        form.requestSubmit(submit);
      },
      true
    );

    updateDeliveryAddress();

    getCart()
      .then(restoreRequest)
      .catch(
        error=>
          setStatus(
            status,
            error.message,
            true
          )
      );
  };

  const boot=scope=>
    scope
      .querySelectorAll('[data-kpc-quote]')
      .forEach(init);

  if(document.readyState==='loading'){
    document.addEventListener(
      'DOMContentLoaded',
      ()=>boot(document)
    );
  }
  else{
    boot(document);
  }

  document.addEventListener(
    'shopify:section:load',
    event=>boot(event.target)
  );

})();


  } catch(e) { console.error(e); }
})();
})();
